import { A, DIV, H2, IMG } from 'sdi/components/elements';
import { navigateMapAndTable } from '../events/route';
import { setTheme } from '../events/app';
import { Theme } from '../remote';
import { getThemes } from '../queries/qa';
import tr from 'sdi/locale';
import { fromNullable } from 'fp-ts/lib/Option';
import { loadIssueListByTheme } from '../events/qa';
import { getRootUrl } from 'sdi/app';

const goToTheme = (theme: Theme) => {
    loadIssueListByTheme(theme.slug);
    setTheme(theme.slug);
    navigateMapAndTable(theme.slug);
};

const renderTheme = (theme: Theme) =>
    DIV(
        'theme-item',
        DIV(
            { className: 'theme-item__name', onClick: () => goToTheme(theme) },
            theme.name
        ),
        fromNullable(theme.image).fold(
            IMG({
                className: 'img',
                src: 'https://fakeimg.pl/300x300/',
                onClick: () => goToTheme(theme),
            }),
            image =>
                IMG({
                    className: 'img',
                    src: `${image}`,
                    onClick: () => goToTheme(theme),
                })
        ),
        DIV('theme-item__description', theme.description)
    );

const renderThemeBlock = (themes: Theme[]) => themes.map(renderTheme);

const render = () =>
    DIV(
        'index__wrapper index',
        DIV(
            'index-content',
            DIV(
                'theme-list-header',
                H2('', 'OSMOA'),
                DIV(
                    '',
                    'Un outil de contrôle qualité et de suivi des modifications des données OpenStreetMap. Choisissez un thème ci-dessous et explorer les derniers éléments ajoutés dans OpenStreetMap!'
                ),
                A(
                    { className: '', href: `${getRootUrl('qa/about')}` },
                    'À propos'
                )
            ),

            DIV(
                'theme-list',
                ...getThemes().fold([DIV('', tr.qa('no_themes'))], themes =>
                    renderThemeBlock(themes)
                )
            )
        )
    );

export default render;
